export default __webpack_public_path__ + "static/media/sticker-l.19b3c9ce.png";